const basic = [
  { name: "nome", label: "Nome Completo" },
  { name: "cpf", label: "CPF" },
  { name: "telefone", label: "Telefone" },
  { name: "email", label: "E-mail" },
].map((field) => ({ ...field, drawer: "basic" }));

const personal = [
  { name: "data_de_nascimento", label: "Data de Nascimento" },
  { name: "grau_de_instrucao", label: "Grau de Instrução" },
  { name: "genero", label: "Gênero" },
  { name: "codigo_pais_nacionalidade", label: "País de nacionalidade" },
  { name: "raca_cor", label: "Raça/Cor" },
  { name: "estadonascimento", label: "Estado de Nascimento (UF)" },
  { name: "codigo_municipionascimento", label: "Município de Nascimento" },
  { name: "estado_civil", label: "Estado Civil" },
  { name: "nome_mae", label: "Nome da Mãe" },
  { name: "deficiente_fisico", label: "Possui Deficiência Física?" },
  { name: "recebia_seguro_desemprego", label: "Recebia seguro desemprego?" },
].map((field) => ({ ...field, drawer: "personal" }));

const address = [
  { name: "tipo_endereco", label: "Tipo de Endereço" },
  { name: "cep", label: "CEP" },
  { name: "endereco", label: "Endereço" },
  { name: "endereco_numero", label: "Número" },
  { name: "endereco_bairro", label: "Bairro" },
  { name: "endereco_cidade", label: "Cidade" },
  { name: "endereco_estado", label: "Estado (UF)" },
  { name: "municipio_endereco", label: "Cidade" },
  { name: "codigo_pais_endereco", label: "País de endereço" },
].map((field) => ({ ...field, drawer: "address" }));

const professional = [
  { name: "forma_pagamento", label: "Meio de pagamento" },
  { name: "pagamento_tipo_conta", label: "Tipo da Conta" },
  { name: "forma_calculo", label: "Forma de pagamento" },
].map((field) => ({ ...field, drawer: "professional" }));

const admission = [
  { name: "cargo", label: "Cargo" },
  { name: "valor_salario", label: "Salário" },
  { name: "data_admissao", label: "Data de admissão" },
  { name: "tipo_vinculo", label: "Vínculo empregatício" },
  { name: "multiplos_vinculos", label: "Múltiplos Vínculos?" },
  {
    name: "pagou_contribuicao_sindical",
    label: "Pagou contribuição sindical?",
  },
  { name: "jornada", label: "Jornada do empregado" },
  { name: "horario", label: "Horário" },
  { name: "horario_intervalo", label: "Horário de intervalo/almoço" },
  { name: "categoria", label: "Categoria" },
  { name: "tipo_indicativo_admissao", label: "Tipo indicativo da admissão" },
  { name: "tipo_admissao", label: "Tipo de admissão" },
  {
    name: "contrato_experiencia",
    label: "Possui Contrato de Experiência?",
    validation: "1",
    required: [
      { name: "dias_experiencia", label: "Quantidade de dias de experiência" },
      { name: "inicio_experiencia", label: "Início da experiência" },
      { name: "fim_experiencia", label: "Fim da experiência" },
    ].map((field) => ({ ...field, drawer: "admission" })),
  },
].map((field) => ({ ...field, drawer: "admission" }));

export const personRequiredFields = [
  ...basic,
  ...personal,
  ...address,
  ...professional,
  ...admission,
];
